module.exports = {"views.activatePartnerSuccess.heading":"Erfolg!","views.activatePartnerSuccess.body":"Ihr Abonnement wurde erfolgreich aktiviert."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/views/ActivatePartnerSuccess.json
// module id = 858
// module chunks = 0